module.exports = __webpack_public_path__ + "images/common_icon_up.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/common_icon_up.png
// module id = 850
// module chunks = 121